import React, { useState } from "react";
import Loader from "../../../components/loaders/loader";
import TableView from "./display-table/table-view";
import { useTranslation } from "react-i18next";
import { useGetdisplayQuery } from "../../../store/Reducer/display";
import AddDisplayModal from "./components/add-display-modal";
import Button from "../../../components/buttons/button";

const DisplayView = ({isPlaylist,setIsPlayList,setDeviceId}) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const { data, isLoading } = useGetdisplayQuery({});

  const openModal = (edit = false, rowData = null) => {
    setIsEdit(edit);
    setSelectedRowData(rowData);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsEdit(false);
    setSelectedRowData(null);
    setIsOpen(false);
  };

  return (
    
    <>
      <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0 md:space-x-4 py-4">
        <div className="w-full flex justify-between items-center">
          <div className="heading">
            <h1 className="text-2xl sm:text-2xl font-bold text-slate-800 flex items-center">
              Displays
            </h1>
          </div>

          <Button
            text="Add Display"
            type="button"
            className="px-6 text-nowrap"
            onClick={() => openModal(false)}
          />
        </div>
      </div>

      {isLoading ? (
        <div className="pt-16 flex justify-center mt-12 items-center">
          <Loader />
        </div>
      ) : (
        <>
          <TableView
            displaydata={data?.data}
            onEditRow={(rowData) => openModal(true, rowData)}
            isPlaylist={isPlaylist}
            setIsPlayList={setIsPlayList}
            setDeviceId={setDeviceId}
          />
        </>
      )}

      <AddDisplayModal
        isOpen={isOpen}
        closeModal={closeModal}
        isEdit={isEdit}
        rowData={selectedRowData}
      />
    </>
  );
};

export default DisplayView;
